<template>
   <div class="w-full surface-100 py-4 xl:py-8 md:py-6 sm:py-5">
		<div class="center px-2">
			<div class="flex p-2 main_title text-800 font-semibold  align-items-center text-center
				mb-2 xl:mb-5 lg:mb-4 md:mb-3  
				text-2xl xl:text-6xl lg:text-5xl md:text-5xl sm:text-4xl">
				{{ tableContent[lang_].title }}
			</div>
			<div class="w-full flex flex-column">
				<div class="flex bg-green-100 xl:surface-0 lg:surface-0 md:surface-0 flex-row 2xl:flex xl:flex lg:flex md:flex text-700 text-xl 
					pt-2 xl:p-3 lg:pl-2 lg:pr-2 lg:pt-3 lg:pb-3 md:pl-1 md:pr-1 md:pt-3 md:pb-3 
					border-round-top-xl xl:border-round-top-3xl">
					<div class="hidden xl:flex lg:flex md:flex flex-1 px-3">
						{{ tableContent[lang_].head.left }}
					</div>
					<div class="hidden xl:flex lg:flex md:flex flex-1 px-3">
						{{ tableContent[lang_].head.center }}
					</div>
					<div class="hidden xl:flex lg:flex md:flex flex-1 px-3">
						{{ tableContent[lang_].head.right }}
					</div>
				</div>
				<div class="flex bg-green-100 text-green-700 flex-column xl:flex-row lg:flex-row md:flex-row
					justify-tableContent-center align-items-left
					px-1 py-3 xl:px-3 xl:py-4 
					xl:border-left-2 xl:border-right-2 border-green-100">
					<div class="flex flex-1 
						text-2xl xl:text-5xl
						font-medium xl:font-bold
						px-3 
						mb-2 text-green-600">
						{{ tableContent[lang_].payway.left }}
					</div>
					<div class="flex flex-1 
						text-sm xl:text-lg lg:text-md md:text-md
						px-3
						mb-3 xl:mb-0 lg:mb-0 md:mb-0 
						max-w-20rem
						line-height-2">
						{{ tableContent[lang_].payway.center }}
					</div>
					<div class="flex flex-1 px-3 
						text-xl xl:text-5xl lg:text-4xl md:text-3xl 
						text-right align-items-right">
						<span class="flex xl:hidden lg:hidden md:hidden mr-1">{{ tableContent[lang_].comission}}:</span>
						{{ tableContent[lang_].payway.right }}
					</div>
				</div>
				<div class="flex surface-0 text-700 flex-column xl:flex-row lg:flex-row md:flex-row
					justify-tableContent-center align-items-left
					pl-1 pr-1 pt-3 pb-3 xl:pl-3 xl:pr-3 xl:pt-4 xl:pb-4
					border-bottom-2 border-300">
					<div class="flex flex-1 px-3 text-2xl xl:text-4xl mb-2">
						{{ tableContent[lang_].binance.left }}
					</div>
					<div class="flex flex-1 
						text-sm xl:text-lg lg:text-md md:text-md
						px-3
						mb-3 xl:mb-0 lg:mb-0 md:mb-0 
						max-w-20rem
						line-height-2">
						{{ tableContent[lang_].binance.center }}
					</div>
					<div class="flex flex-1 px-3 
						text-xl xl:text-5xl lg:text-4xl md:text-3xl 
						text-right align-items-right">
						<span class="flex xl:hidden lg:hidden md:hidden mr-1">{{ tableContent[lang_].comission }}:</span>
						{{ tableContent[lang_].binance.right }}
					</div>
				</div>
				
				<div class="flex surface-0 text-700 flex-column xl:flex-row lg:flex-row md:flex-row
					justify-tableContent-center align-items-left
					pl-1 pr-1 pt-3 pb-3 xl:pl-3 xl:pr-3 xl:pt-4 xl:pb-4 
					border-bottom-2 border-300">
					<div class="flex flex-1 px-3 text-2xl xl:text-4xl mb-2">
						{{ tableContent[lang_].local.left }}
					</div>
					<div class="flex flex-1 
						text-sm xl:text-lg lg:text-md md:text-md
						px-3
						mb-3 xl:mb-0 lg:mb-0 md:mb-0 
						max-w-20rem
						line-height-2">
						{{ tableContent[lang_].local.center }}
					</div>
					<div class="flex flex-1 px-3 
						text-xl xl:text-5xl lg:text-4xl md:text-3xl 
						text-right align-items-right">
						<span class="flex xl:hidden lg:hidden md:hidden mr-1">{{ tableContent[lang_].comission }}:</span>
						{{ tableContent[lang_].local.right }}
					</div>
				</div>
				<div class="flex surface-0 text-700 flex-column xl:flex-row lg:flex-row md:flex-row
					justify-tableContent-center align-items-left
					pl-1 pr-1 pt-3 pb-3 xl:pl-3 xl:pr-3 xl:pt-4 xl:pb-4 
					border-bottom-2 border-300">
					<div class="flex flex-1 px-3 text-2xl xl:text-4xl mb-2">
						{{ tableContent[lang_].gold.left }}
					</div>
					<div class="flex flex-1 
						text-sm xl:text-lg lg:text-md md:text-md
						px-3
						mb-3 xl:mb-0 lg:mb-0 md:mb-0 
						max-w-20rem
						line-height-2">
						{{ tableContent[lang_].gold.center }}
					</div>
					<div class="flex flex-1 px-3 
						text-xl xl:text-5xl lg:text-4xl md:text-3xl 
						text-right align-items-right">
						<span class="flex xl:hidden lg:hidden md:hidden mr-1">{{ tableContent[lang_].comission}}:</span>
						{{ tableContent[lang_].gold.right }}
					</div>
				</div>
				<div class="flex surface-0 text-700 flex-column xl:flex-row lg:flex-row md:flex-row
					justify-tableContent-center align-items-left
					pl-1 pr-1 pt-3 pb-3 xl:pl-3 xl:pr-3 xl:pt-4 xl:pb-4
					border-round-bottom-xl xl:border-round-bottom-3xl">
					<div class="flex flex-1 px-3 text-xl xl:text-2xl mb-2">
						{{ tableContent[lang_].other.left }}
					</div>
					<div class="flex flex-1 
						text-sm xl:text-lg lg:text-md md:text-md
						px-3
						mb-3 xl:mb-0 lg:mb-0 md:mb-0 
						max-w-20rem
						line-height-2">
						{{ tableContent[lang_].other.center }}
					</div>
					<div class="flex flex-1 px-3 
						text-xl xl:text-5xl lg:text-4xl md:text-3xl 
						text-right align-items-right">
						<span class="flex xl:hidden lg:hidden md:hidden mr-1">{{ tableContent[lang_].comission }}:</span>
						{{ tableContent[lang_].other.right }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
export default {
    data(){
        return{
            tableContent: {
                en: {
                    title: "How to transfer money from Russia to Asia?",
                    comission: "Commission",
                    head: {
                        left: "Transfer method",
                        center: "Features",
                        right: "Final commission",
                    },
                    binance: {
                        left: "Binance",
                        center: "Registration only by passport. The complexity of working with cryptocurrency and an incomprehensible interface. If you make a mistake, it's easy to lose money.",
                        right: "3–5%",
                    },
                    payway: {
                        left: "PayWave",
                        center: "Profitable. Fast. Convenient. Fixed commission. 24/7 support and money back guarantee.",
                        right: "3%",
                    },
                    local: {
                        left: "Local exchangers",
                        center: "A high probability of fraud. An overpriced rate. High commission. Long wait for the transfer and the inability to return the money.",
                        right: "10–15%",
                    },
                    gold: {
                        left: "Gold crown & Paysend",
                        center: "Overpriced Gold Crown conversion rate of 5-10%. To transfer via Paysend, you need a foreign card.",
                        right: "6-10%",
                    },
                    other: {
                        left: "Bank card of Kazakhstan / Georgia / Kyrgyzstan",
                        center: "You need to have a card worth from 30k rubles. It is necessary to pay a commission for transfer to Kazakhstan / Georgia / Kyrgyzstan and related commissions.",
                        right: "8–10%"
                    }
                },
                ru: {
                    title: "Как можно перевести деньги из России в страны Азии?",
                    comission: "Комиссия",
                    head: {
                        left: "Cпособ перевода",
                        center: "Особенности",
                        right: "Итоговая комиссия",
                    },
                    binance: {
                        left: "Бинанс",
                        center: "Регистрация только по паспорту. Сложность работы с криптовалютой и непонятный интерфейс. В случае ошибки деньги легко потерять.",
                        right: "3–5%",
                    },
                    payway: {
                        left: "PayWave",
                        center: "Выгодно, быстро, удобно, фиксированная комиссия, круглосуточная поддержка и гарантия возврата.",
                        right: "3%",
                    },
                    local:{
                        left: "Местные обменники",
                        center: "Большая вероятность обмана, завышенный курс, высокая комиссия, долгое ожидание перевода и невозможность вернуть деньги.",
                        right: "10–15%",
                    },
                    gold: {
                        left: "Золотая корона и Paysend",
                        center: "Завышенный курс конвертации золотой короны 5-10%. Для перевода через Paysend нужна иностранная карта.",
                        right: "6–10%",
                    },
                    other: {
                        left: "Банковская карта Казахстана / Грузии / Киргизии",
                        center: "Нужно иметь карту стоимостью от 30 тыс. рублей. Необходимо платить комиссию за перевод в Казахстан / Грузию / Киргизию и сопутствующие комиссии.",
                        right: "8–10%"
                    }
                }
            }
        }
    },
    computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'en'
        },  
    },
}
</script>